// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1ckxe","info":"Note_info__DmiMS","note":"Note_note__2hfIf","actions":"Note_actions__el0aZ"};